import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useAppSetting } from "../../context/appSettingContext";
import logo from "../../images/192by192.png";
import animationgif from "../../images/animation.gif";
import AnimatedPage from "../FramerMotion/AnimatedPage";

const NoAccess = () => {
    const [loading, setLoading] = useState(true);
    const { appSettings } = useAppSetting();
    const { LogoURL } = appSettings;

    useEffect(() => {
        const determineDelay = () => {
            const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

            if (connection && connection.effectiveType) {
                switch (connection.effectiveType) {
                    case "4g":
                        return 700;
                    case "3g":
                        return 1500;
                    case "2g":
                    case "slow-2g":
                        return 2500;
                    default:
                        return 1000;
                }
            }
            return 1000; // fallback if unsupported
        };

        const delay = determineDelay();
        const timer = setTimeout(() => setLoading(false), delay);

        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <AnimatedPage className="h-100">
                <div className={`transition-4-ease h-100 w-100 position-absolute z-3 p-0 d-block`}>
                    <img
                        src={animationgif}
                        alt="Background animation"
                        className="w-100 h-100 position-absolute object-fit-cover"
                        style={{
                            filter: `blur(5px)`,
                            transform: "scale(1.10)"
                        }}
                    />
                    <div className="w-100 h-100 bg-wafaa-purple-opacity-50 position-relative align-items-center justify-content-center d-flex flex-column">
                        <motion.img
                            src={LogoURL}
                            onError={(e) => {
                                e.target.src = logo;
                            }}
                            alt="Logo"
                            animate={{ scale: [1, 1.1, 1] }} // breathing animation
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut",
                            }}
                        />
                    </div>
                </div>
            </AnimatedPage>
        );
    }

    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className="text-center">
                <h2 className="mb-4">Oops! Page Not Found</h2>
                <a href="/" className="btn text-white bg-wafaa-purple-2">
                    Go Back Home
                </a>
            </div>
        </div>
    );
};

export default NoAccess;
